<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 9787 9787"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <path class="fil0"
          d="M9787 8792c0,550 -445,995 -995,995l-7797 0c-549,0 -995,-445 -995,-995l0 -7797c0,-549 446,-995 995,-995l7797 0c550,0 995,446 995,995l0 7797z"/>
   </g>
    <g id="Vrstva_x0020_1_0">
    <path class="fil1"
          d="M5174 4691c0,-443 453,-494 453,36 0,381 -453,417 -453,-36zm-3114 -3259l0 7206c0,218 296,163 543,163 168,0 183,-146 182,-271 -19,-2249 -1,-4575 -1,-6826 175,-41 212,-8 346,-4l216 -14c76,0 100,13 146,14l216 -14c76,0 101,13 146,14l216 -14c76,0 101,13 147,14l215 -14c76,0 101,13 147,14l233 -14c91,0 81,16 163,18 0,404 -17,2451 14,2685 13,99 -12,104 -10,174 25,929 14,1875 14,2808 63,17 463,297 551,355 97,64 171,120 268,184 95,64 176,118 271,182l812 546c43,29 85,55 129,88 151,115 234,75 540,75 90,0 163,-73 163,-163l0 -7206c0,-218 -219,-452 -434,-452l-4798 0c-215,0 -435,237 -435,452z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Door',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #00A0E3;
  fill-rule: nonzero
}
</style>
